import { render, staticRenderFns } from "./WorkMultipleKeyValueFilter.vue?vue&type=template&id=1895e455&scoped=true"
import script from "./WorkMultipleKeyValueFilter.vue?vue&type=script&lang=js"
export * from "./WorkMultipleKeyValueFilter.vue?vue&type=script&lang=js"
import style0 from "./WorkMultipleKeyValueFilter.vue?vue&type=style&index=0&id=1895e455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895e455",
  null
  
)

export default component.exports